import gql from 'graphql-tag';

export default gql`
  query ($applicationTeachersAidId: ID!) {
    applicationTeachersAid(applicationTeachersAidId: $applicationTeachersAidId) {
      applicationTeachersAidId
      status
      signedAt
      new
      organizationType
      nonProfitOrganizations
      termId
      isContinuation
      term {
        id
        termId
        type
        year
        startDate
        endDate
        termFormatted
        termFormattedShort
      }
      numFreeLunch
      numReducedLunch
      numTotalEnrollment
      demographicAsian
      demographicBlack
      demographicHispanic
      demographicWhite
      certifiedProgramRules
      certififedVerification
      certifiedAgreement
      certifiedNonDiscrimination
      nameSignFirst
      nameSignSecond
      nameSignThird
      submittedAt
      educator {
        firstName
        lastName
        phone
        email
      }
      school {
        schoolId
        name
        type
        districtId
        address1
        address2
        city
        county
        state
        zip
        gradesServed
        teachersAidSchoolNumber
        applicationsTeachersAid {
          applicationTeachersAidId
          submittedAt
          signedAt
          status
          isContinuation
        }
        teachers {
          teacherId
          firstName
          lastName
          title
          phone
          email
          proxyTeacher
          gradesTaught
          subjectsTaught
          numStudentsTaughtPerYear
        }
        siteCoordinator {
          teamMemberId
          firstName
          lastName
          title
          phone
          email
          type
        }
        principal {
          teamMemberId
          firstName
          lastName
          title
          phone
          email
          type
        }
      }
    }
  }
`;
